import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/error_outline.png'


const _hoisted_1 = { class: "delete-order-content" }
const _hoisted_2 = { class: "delete-order-content__title" }
const _hoisted_3 = { class: "delete-order-content__label" }
const _hoisted_4 = { class: "delete-order-content__button-container button-container" }

import { i18n } from '@/i18n';
import { ref, watch } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'AttentionOrderDeleteModal',
  props: {
    modalState: { type: Boolean, default: false }
  },
  emits: ["canceled", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const selectedConfirm = ref<boolean>(false);
const cancelReason = ref<string>('');

/**
 * キャンセル理由を更新する
 * @param value - キャンセル理由
 */
const updateCancelReason = (value: Event) => {
  const target = value.target as HTMLTextAreaElement;
  cancelReason.value = target.value;
};

watch(
  () => props.modalState,
  (newVal, oldVal) => {
    // false -> true になった場合、変数を初期化する
    if (oldVal === false && newVal === true) {
      selectedConfirm.value = false;
      cancelReason.value = '';
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "confirm-modal-container",
    "modal-size": 'max-content',
    "modal-width": 500,
    "aspect-ratio": true,
    "stretch-container": true,
    "scroll-off": true,
    padding: '16px',
    "modal-state": _ctx.modalState,
    "border-radius": '16px',
    "md-click-out-side-to-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "delete-order-content__icon",
          src: _imports_0
        }, null, -1)),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('納期または発注数量が確定してるものが削除対象に含まれています。')), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('以下の合意があることを確認してから対象を削除してください。')), 1),
        _createVNode(RowCheckBox, {
          modelValue: selectedConfirm.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedConfirm).value = $event)),
          "label-text": _unref(t)('仕入先との発注キャンセルの合意'),
          class: "delete-order-content__confirm-check-box confirm-check-box",
          "is-checked": selectedConfirm.value,
          onChangeStatus: _cache[1] || (_cache[1] = ($event: any) => (selectedConfirm.value = $event))
        }, null, 8, ["modelValue", "label-text", "is-checked"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextButton, {
            "button-style": 'btn-secondary-error',
            size: 'btn-md',
            "on-click": () => emits('canceled'),
            class: "button-container--cancel-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click"]),
          _createVNode(TextButton, {
            "button-style": 'btn-error',
            size: 'btn-md',
            disabled: !selectedConfirm.value,
            "on-click": () => emits('confirm', cancelReason.value),
            class: "button-container--confirm-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('削除')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["disabled", "on-click"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})